






















import { Component, Prop, Vue } from 'vue-property-decorator'
import Headline from './headline.vue'
import Table from './table.vue'
import OrderedList from './ordered-list.vue'
import ImageContent from './image.vue'
import Youtube from './youtube.vue'
import Twitter from './twitter.vue'
import URL from './url.vue'
import WebPage from './webpage.vue'
import linkify from 'linkifyjs/string'
import { nl2br } from '@/components/utils'

@Component<CardInner>({
  components: {
    Headline,
    Table,
    OrderedList,
    ImageContent,
    Youtube,
    Twitter,
    URL,
    WebPage
  }
})
export default class CardInner extends Vue {
  @Prop()
  private type!: string
  @Prop({ default: '' })
  private value!: string
  @Prop()
  private html!: string

  @Prop()
  private handleImageMeasure!: (width: number, height: number) => void
  @Prop()
  private handleHTMLMeasure!: (ratio: number, defaultHeight: number) => void
  @Prop()
  private handleURL!: (url: string) => void

  private getLinkified(): string {
    return nl2br(linkify(this.value))
  }
}
